import React from "react";
import classnames from "classnames";
import "./Label.scss";

const Label = ({ children, color }) => (
  <span className={classnames("label", color)}>{children}</span>
);

export default Label;
